<template>
    <div>
        <vs-sidebar
            click-not-close
            position-right
            spacer
            parent="body"
            color="primary"
            default-index="1"
            class="new-chat-flows-view-sidebar items-no-padding"
            v-model="sidebarIsActive"
        >

            <div class="mt-6 flex items-center justify-between px-6">
                <h4> {{ context === 'update' ? 'ATUALIZAR' : 'CRIAR' }} SEGMENTAÇÃO </h4>
                <feather-icon
                    icon="XIcon"
                    @click.stop="sidebarIsActive = false"
                    class="cursor-pointer"
                />
            </div>

            <vs-divider class="mb-0"/>


            <div class="mt-10 ml-4 w-11/12">

                <span class="ml-1 text-sm">
                    Nome da Segmentação
                </span>

                <vs-input class="w-full" v-model="segmentName"/>
                <span v-show="segmentName.length >= 55 && context === 'update'" class="ml-2 mt-6 text-sm" style="color: #ff0000cc"> Número máximo atingido </span>

            </div>

            <div class="mt-6 ml-4 w-11/12" v-if="hasRedirectFlow">

                <span class="ml-1 text-sm">
                    Departamento
                </span>

                <v-select
                    label="name" 
                    :options="departments"
                    :reduce="departments => departments.id"
                    v-model="departmentId"
                    class="new-chat-flows-view-sidebar-select"
                />

                <span v-show="hasRedirectFlow && departmentId === null && context === 'update'" class="ml-2 mt-6 text-sm" style="color: #ff0000cc"> Você deve vincular essa opção a um departamento </span>

            </div>

            <div class="mt-6 ml-4 w-11/12">
                <vs-checkbox v-model="hasRedirectFlow">
                    Vincular a um Departamento
                </vs-checkbox>
            </div>
            
            <div class="flex flex-wrap items-center p-6" slot="footer">

                <vs-button class="mr-6" @click.stop="context === 'create' ? create() : update()" :disabled="
                    (
                        (
                            (hasRedirectFlow ? departmentId === null : false) ||
                            segmentName.length === 0    ||
                            segmentName.trim() === ''   ||
                            segmentName.length >= 55
                        ) &&
                        context === 'create'
                    )
                ">
                    Salvar
                </vs-button>

                <vs-button type="border" color="danger" @click.stop="sidebarIsActive = false">
                    Cancelar
                </vs-button>

            </div>

        </vs-sidebar>
    </div>

</template>

<script>

    import vSelect from 'vue-select';

    export default {
        name: 'NewChatFlowsViewSidebar',
        data() {
            return {
                segmentName: '',
                departmentId: null,
                hasRedirectFlow: false
            }
        },
        methods: {
            async create() {
                await this.$store.dispatch("prompt/create",
                    {
                        key: '{options}',
                        name: this.segmentName,
                        prompt_id: 1,
                        ...this.hasRedirectFlow ?  { department_id: Number( this.departmentId ) } : {}
                    }
                )
                .then( () => {
                    this.sidebarIsActive = false
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'A Segmentação foi criada com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao criar Segmentação!',
                            time: 5000
                        }
                    );
                });
            },
            async update() {
                if ( this.hasRedirectFlow && this.departmentId === null ) {
                    return this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Aviso!',
                            text: 'Você precisa vincular um departamento!',
                            time: 5000
                        }
                    );
                }

                if ( this.segmentName.length >= 55 ) {
                    return this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'O cumprimento máximo do campo de "Nome da Segmentação" foi atingido!',
                            time: 5000
                        }
                    );
                }

                await this.$store.dispatch("prompt/update",
                    {
                        id: this.data.id,
                        name: this.segmentName,
                        department_id: Number( this.departmentId ),
                        has_redirect_flow: this.hasRedirectFlow
                    }
                )
                .then( () => {
                    this.sidebarIsActive = false
                    this.$vs.notify(
                        {
                            color: 'success',
                            title: 'Sucesso!',
                            text: 'A Segmentação foi atualizada com Sucesso!',
                            time: 5000
                        }
                    );
                })
                .catch( () => {
                    this.$vs.notify(
                        {
                            color: 'danger',
                            title: 'Erro!',
                            text: 'Algo deu errado ao atualizar a Segmentação!',
                            time: 5000
                        }
                    );
                });
            }
        },
        computed: {
            sidebarIsActive: {
                get() {
                    return this.isActive;
                },
                set( value ) {
                    if ( !value ) {
                        this.$emit('isActiveFalse');
                    }
                }
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            },
            context: {
                type: String,
                required: true,
                default: 'create'
            },
            departments: {
                type: Array,
                required: true,
                default: []
            },
            data: {
                type: Object,
                required: false,
                default: {
                    id: null,
                    key: null,
                    name: null,
                    option: null,
                    prompt_id: null,
                    department_id: null
                }
            }
        },
        watch: {
            data( value ) {
                if ( value && value.department_id ) {
                    return this.hasRedirectFlow = Boolean( value.department_id && true );
                }

                return this.hasRedirectFlow = false;
            },
            isActive( value ) {
                if ( value && this.context === 'create' ) {
                    this.segmentName  = '';
                    this.departmentId = null;
                }

                if ( value && this.context === 'update' ) {
                    this.segmentName  = this.data.name || '';
                    this.departmentId = this.data.department_id;
                }
            },
            segmentName( value ) {
                if ( value && value.length === 55 ) {
                    this.$vs.notify(
                        {
                            color: 'warning',
                            title: 'Atenção!',
                            text: 'Número máximo de caracteres atingido no campo nome da segmentação!',
                            time: 5000
                        }
                    );
                }
            },
        },
        components: {
            vSelect
        },
        emits: [
            'isActiveFalse'
        ]
    }

</script>

<style lang="scss" scoped>

    .new-chat-flows-view-sidebar {

        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 400px;
            max-width: 90vw;
        }

    }

</style>